/* eslint-disable no-undef */
import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Popover,
  Grid,
  ClickAwayListener,
  Alert,
  Tooltip,
  Snackbar,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import SearchIcon from "@mui/icons-material/Search";
import "react-datepicker/dist/react-datepicker.css";
import "../../../../Asset/scss/Homepages/header.scss";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { ConfigProvider, DatePicker, Space } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/th";
import "dayjs/locale/en";
import locale from "antd/es/locale/th_TH";
import { useSelector, useDispatch } from "react-redux";
import {
  getMarinaDetail,
  getProvinceDetail,
  getDestinationDetail,
} from "../../../../redux/centerData/CenterDataSlice";
import { useNavigate } from "react-router-dom";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import CloseIcon from "@mui/icons-material/Close";

import Divider from "@mui/material/Divider";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";

function SearchForm({ onApplyPromo }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  // แสดงเฉพาะวันที่ โดยตัดเวลาออกจากค่า ISO เช่น 2027-12-01T00:00:00.000Z
  const formatDateOnly = (date) => {
    if (!date) return "";

    const dateString = String(date);

    // ถ้ามีเวลา เช่น 2027-12-01T00:00:00.000Z
    // ตัดส่วนเวลาออกก่อน
    const dateOnly = dateString.split("T")[0];

    // รองรับทั้ง YYYY-MM-DD และ YYYY/MM/DD
    const parts = dateOnly.split(/[-/]/);

    if (parts.length === 3) {
      const [year, month, day] = parts;

      return `${year}/${String(month).padStart(2, "0")}/${String(day).padStart(2, "0")}`;
    }

    return dateOnly;
  };

  // เช็กว่าโปรโมชันใช้ได้ตลอดเวลาหรือไม่
  const isAllTimePromo = (promo) => {
    if (!promo) return false;
    return (
      Number(promo.is_all_time) === 1 ||
      promo.is_all_time === true ||
      !promo.end_date_valid // end_date_valid เป็นค่าว่าง/null
    );
  };

  // สร้างข้อความช่วงเวลาที่ใช้ได้
  const getPromoValidText = (promo) => {
    if (!promo) return "";

    const start = formatDateOnly(promo.start_date_valid);

    if (isAllTimePromo(promo)) {
      return start
        ? `${start} - ${t("unlimited")}`
        : t("unlimited");
    }

    return `${start} - ${formatDateOnly(promo.end_date_valid)}`;
  };

  const [currentLanguage, setCurrentLanguage] = useState(
    localStorage.getItem("selectedLanguage") || i18n.language,
  );

  const [promoCodeInput, setPromoCodeInput] = useState("");
  const [matchedPromo, setMatchedPromo] = useState(null);

  const [openPromoModal, setOpenPromoModal] = useState(false);
  const [promoType, setPromoType] = useState("code");
  const [selectedPromotion, setSelectedPromotion] = useState(null);

  const [discountValue, setDiscountValue] = useState("");
  const [discountType, setDiscountType] = useState("percent");

  dayjs.locale(currentLanguage);

  const storedDestination = JSON.parse(localStorage.getItem("Destination"));
  const initialDestination = storedDestination
    ? { ...storedDestination }
    : { name: "", eng: "", type: "" };
  const [destination, setDestination] = useState(initialDestination);

  const [tripType, setTripType] = useState(localStorage.getItem("Trip") || "");

  const [date, setDate] = useState(() => {
    const storedDate = localStorage.getItem("selectedDate");
    if (storedDate) {
      const dates = storedDate.split(",");
      if (dates.length === 1) {
        return dayjs(dates[0], "YYYY/MM/DD");
      } else if (dates.length === 2) {
        return [dayjs(dates[0], "YYYY/MM/DD"), dayjs(dates[1], "YYYY/MM/DD")];
      }
    }
    return null;
  });

  const [counters, setCounters] = useState(
    JSON.parse(localStorage.getItem("Passenger")) || {
      adults: 1,
      children: 0,
      infants: 0,
    },
  );

  const passengerOptions = [
    {
      key: "adults",
      labelKey: "adults",
      type: "adult",
      rangeKey: "adultsRange",
    },
    {
      key: "children",
      labelKey: "children",
      type: "child",
      rangeKey: "childrenRange",
    },
    {
      key: "infants",
      labelKey: "infants",
      type: "infant",
      rangeKey: "infantsRange",
    },
  ];

  useEffect(() => {
    const storedCounters = JSON.parse(localStorage.getItem("Passenger"));
    if (!storedCounters || storedCounters.adults < 1) {
      localStorage.setItem(
        "Passenger",
        JSON.stringify({ ...counters, adults: 1 }),
      );
    }
  }, []);

  const todos = useSelector((state) => state);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      dispatch(getMarinaDetail({})),
      dispatch(getProvinceDetail({})),
      dispatch(getDestinationDetail({})),
    ])
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [dispatch]);

  const promoResults = todos?.PromotionSlice?.Promotion?.results || [];

  const promotionList = promoResults.map((item) => ({
    label: item.name_promotion, // ให้ Autocomplete ใช้ชื่อนี้
    value: item, // เก็บทั้ง object
  }));

  const handlePromoCodeChange = (e) => {
    const value = e.target.value;
    setPromoCodeInput(value);

    const results = todos?.PromotionSlice?.Promotion?.results || [];
    const matched = results.find(
      (item) => item.promotion_code?.toLowerCase() === value.toLowerCase(),
    );

    setMatchedPromo(matched || null);
  };

  const handleDestinationChange = (event, value) => {
    const destinationValue = value ? value : null;
    setDestination(destinationValue);
    localStorage.setItem("Destination", JSON.stringify(destinationValue));
  };

  const marinaIds = new Set(
    todos?.CenterDataSlice?.Marina?.results?.map(
      (marina) => marina.id_province,
    ),
  );
  const marinaResults = todos?.CenterDataSlice?.Marina?.results || [];
  const provinceResults = todos?.CenterDataSlice?.Province?.results || [];
  const destinationResults = todos?.CenterDataSlice?.Destination?.results || [];

  const generateOptions = (items, nameKeyThai, nameKeyEng, type) => {
    return items.map((item) => ({
      name: currentLanguage === "th" ? item[nameKeyThai] : item[nameKeyEng],
      eng: item[nameKeyEng],
      type: t(type),
    }));
  };

  const provincesWithOptions = provinceResults.filter((province) =>
    marinaIds.has(province.ProvinceID),
  );
  const marinasWithOptions = marinaResults;
  const destinationsWithOptions = destinationResults;

  const optionsA = [
    ...generateOptions(
      provincesWithOptions,
      "ProvinceThai",
      "ProvinceEng",
      "province",
    ),
    ...generateOptions(
      marinasWithOptions,
      "name_marina_th",
      "name_marina_en",
      "marina",
    ),
    ...generateOptions(
      destinationsWithOptions,
      "name_destination_th",
      "name_destination_en",
      "destination",
    ),
  ];

  const handleTripTypeChange = (value) => {
    setTripType(value);
    setDate("");
    localStorage.setItem("Trip", value);
    localStorage.setItem("selectedDate", "");
  };

  const handleDatePickerChange = (selectedDates) => {
    setDate(selectedDates);
    if (!selectedDates) {
      setTripType("");
      localStorage.removeItem("Trip");
    }
    if (selectedDates === null) {
      localStorage.removeItem("selectedDate");
    } else if (Array.isArray(selectedDates)) {
      const dateString = selectedDates
        .map((date) => date.format("YYYY/MM/DD"))
        .join(",");
      localStorage.setItem("selectedDate", dateString);
    } else {
      localStorage.setItem("selectedDate", selectedDates.format("YYYY/MM/DD"));
    }
  };

  const disabledDate = (current) => {
    return current && current < dayjs().startOf("day");
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const boxRef = useRef(null);

  const handleOpenPopover = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const handleCounterChange = (key, operation, event) => {
    event.stopPropagation();

    setCounters((prevCounters) => {
      const newCounters = { ...prevCounters };

      if (operation === "increase") {
        newCounters[key] = (newCounters[key] || 0) + 1;
      } else if (operation === "decrease") {
        if (key === "adults" && newCounters[key] > 1) {
          newCounters[key]--;
        } else if (key !== "adults" && newCounters[key] > 0) {
          newCounters[key]--;
        }
      }

      localStorage.setItem("Passenger", JSON.stringify(newCounters));

      return newCounters;
    });
  };

  useEffect(() => {
    setCurrentLanguage(i18n.language);
  }, [i18n.language]);

  useEffect(() => {
    const storedLanguage = localStorage.getItem("selectedLanguage");
    if (storedLanguage) {
      setCurrentLanguage(storedLanguage);
    }
  }, []);

  const dropdownRef = useRef(null);
  const { RangePicker } = DatePicker;

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowPassengerCount(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const handleButtonClick = () => {
    if (!destination || !destination.eng) {
      setAlertMessage(t("Please select a destination before booking."));
      setShowAlert(true);
      return;
    }

    if (!date) {
      setAlertMessage(t("Please select a date before booking."));
      setShowAlert(true);
      return;
    }

    let url = `/yacht/${destination.eng}`;

    if (tripType) {
      url += `/${tripType}`;
    }

    const totalPassengers =
      parseInt(counters.adults || 0, 10) +
      parseInt(counters.children || 0, 10) +
      parseInt(counters.infants || 0, 10);

    const dateParam = Array.isArray(date)
      ? date.map((d) => d.format("YYYY-MM-DD")).join("_")
      : date?.format("YYYY-MM-DD") || "";

    const queryParams = new URLSearchParams({
      passengers: totalPassengers,
      date: dateParam,
    });

    url += `?${queryParams.toString()}`;

    window.location.href = url;
  };

  const isOptionEqualToValue = (option, value) => {
    return (
      option.name === value?.name &&
      option.eng === value?.eng &&
      option.type === value?.type
    );
  };

  return (
    <Box
      className="container-form"
      sx={{
        flexGrow: 1,
        width: "100%",
        maxWidth: "1200px", // เดสก์ท็อปเต็มบรรทัด
        margin: "auto",
        zIndex: 5,
        padding: { xs: "16px", md: "24px" }, // mobile padding น้อยกว่า
      }}
    >
      <Grid
        container
        spacing={0.8}
        rowGap={1}
        alignItems="center"
        justifyContent="center"
      >
        <Grid item xs={12} sm={12} md={3}>
          <Autocomplete
            id="combo-box-demo"
            options={optionsA}
            value={destination || { name: "", eng: "", type: "" }}
            getOptionLabel={(option) => option.name}
            isOptionEqualToValue={isOptionEqualToValue}
            renderOption={(props, option) => (
              <li
                {...props}
                className="flex-between-center"
              >
                <Typography variant="body1">
                  {option.name}
                  <span className="text-muted-40">
                    &nbsp;&nbsp; - {option.type}
                  </span>
                </Typography>
              </li>
            )}
            sx={{
              width: "100%",
              backgroundColor: "white",
              borderRadius: 8,
              "& .MuiOutlinedInput-root": {
                borderRadius: 8,
                height: "56px",
              },
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={
                  params.inputProps.value ||
                    params.inputProps.value === 0 ||
                    params.selectedItem
                    ? t("enterDestination")
                    : t("enterDestination")
                }
                sx={{
                  "& label.Mui-focused": {
                    color: "#0D47A1",
                    fontWeight: 600,
                    top: 0,
                  },
                  "& label": {
                    color:
                      params.inputProps.value ||
                        params.inputProps.value === 0 ||
                        params.selectedItem
                        ? "rgba(0, 0, 0, 0.6)"
                        : "gray",
                    top:
                      params.inputProps.value ||
                        params.inputProps.value === 0 ||
                        params.selectedItem
                        ? -0
                        : 0,
                  },
                }}
              />
            )}
            className="z-9999"
            onChange={handleDestinationChange}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <TextField
            select
            label={t("Select trip type")}
            variant="outlined"
            size="large"
            value={tripType}
            onChange={(e) => handleTripTypeChange(e.target.value)}
            sx={{
              width: "100%",
              backgroundColor: "white",
              borderRadius: 8,
              "& .MuiOutlinedInput-root": {
                height: "56px",
                borderRadius: 8,
              },
              "& label.Mui-focused": {
                color: "#0D47A1",
                fontWeight: 600,
              },
            }}
          >
            <MenuItem value="HalfDay">{t("Half Day")}</MenuItem>
            <MenuItem value="DayTrip">{t("Full Day")}</MenuItem>
            <MenuItem value="Overnight">{t("Overnight")}</MenuItem>
          </TextField>
        </Grid>

        {tripType && (
          <Grid item xs={12} sm={6} md={3}>
            <Space
              direction="vertical"
              className="ml-1 w-full"
            >
              {tripType === "HalfDay" || tripType === "DayTrip" ? (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <ConfigProvider
                    locale={currentLanguage === "th" ? locale : "en"}
                  >
                    <DatePicker
                      className="custom-range-picker"
                      onChange={handleDatePickerChange}
                      size="15"
                      value={date}
                      picker="date"
                      format="YYYY/MM/DD"
                      disabledDate={disabledDate}
                    />
                  </ConfigProvider>
                </LocalizationProvider>
              ) : (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <ConfigProvider
                    locale={currentLanguage === "th" ? locale : "en"}
                  >
                    <RangePicker
                      className="custom-range-picker"
                      onChange={handleDatePickerChange}
                      size="15"
                      value={date}
                      picker="date"
                      format="YYYY/MM/DD"
                      disabledDate={disabledDate}
                    />
                  </ConfigProvider>
                </LocalizationProvider>
              )}
            </Space>
          </Grid>
        )}

        <ClickAwayListener onClickAway={handleClosePopover}>
          <Grid item xs={12} sm={6} md={3}>
            <Box
              ref={boxRef}
              className="passenger-box"
              onClick={handleOpenPopover}
            >
              <Grid container justifyContent="center" spacing={1}>
                {passengerOptions.map((option) => (
                  <Grid item xs={3} md={3} key={option.key}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: "100%",
                        "@media (max-width:600px)": {
                          height: "12vw",
                          width: "100%",
                        },
                      }}
                    >
                      <Typography
                        variant=""
                        sx={{
                          fontWeight: "bold",
                          marginLeft: "2vw",
                          marginTop: "3px",
                        }}
                        className="ml-1vw"
                      >
                        {counters[option.key]}
                      </Typography>
                      <Typography
                        variant=""
                        align="center"
                        className="adultchildinfant ml-1vw"
                        sx={{
                          marginLeft: "2vw",
                          minWidth: "60px",
                          whiteSpace: "nowrap",
                          "@media (max-width:600px)": {
                            fontSize: "0.5rem",
                            height: "12vw",
                            width: "100%",
                          },
                        }}
                      >
                        {t(option.labelKey)}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
                <Grid
                  item
                  md={1}
                  sx={{
                    marginLeft: "0.5vw",
                    marginTop: "0.5vw",
                    alignItems: "center",
                    "@media (max-width:600px)": {
                      marginTop: "2vw",
                    },
                  }}
                >
                  {anchorEl ? (
                    <ArrowDropUpIcon fontSize="medium" />
                  ) : (
                    <ArrowDropDownIcon fontSize="medium" />
                  )}
                </Grid>
              </Grid>

              <Popover
                open={Boolean(anchorEl)}
                anchorEl={boxRef.current}
                onClose={handleClosePopover}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
              >
                <Box p={2}>
                  {passengerOptions.map((option) => (
                    <div
                      key={option.key}
                      className="flex-between-center mb-10"
                    >
                      <div className="text-left">
                        <Typography variant="" sx={{ fontWeight: "bold" }}>
                          {t(option.labelKey)}
                        </Typography>
                        <Typography variant="body2">
                          {t(option.rangeKey)}
                        </Typography>
                      </div>
                      <div className="flex-center2">
                        <IconButton
                          size="small"
                          onClick={(event) =>
                            handleCounterChange(option.key, "decrease", event)
                          }
                        >
                          <RemoveIcon />
                        </IconButton>
                        <Typography>{counters[option.key] || 0}</Typography>
                        <IconButton
                          size="small"
                          onClick={(event) =>
                            handleCounterChange(option.key, "increase", event)
                          }
                        >
                          <AddIcon />
                        </IconButton>
                      </div>
                    </div>
                  ))}
                </Box>
              </Popover>
            </Box>
          </Grid>
        </ClickAwayListener>

        <Grid item xs={12} sm={6} md={3}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: "100%",
            }}
          >
            <Button
              variant="contained"
              endIcon={<SearchIcon sx={{ color: "white" }} />}
              sx={{
                flex: 1,
                height: "6vh",
                backgroundColor: "#00305b",
                borderRadius: 8,

                "@media (max-width:600px)": {
                  height: "8vh",
                  fontSize: "1rem",
                },
              }}
              onClick={handleButtonClick}
            >
              {t("letsGoButton")}
            </Button>

            <Tooltip
              title="Promo Code"
              arrow
              placement="top"
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#00305b",
                    color: "#fff",
                    fontSize: "0.85rem",
                    borderRadius: "8px",
                    padding: "6px 10px",
                  },
                },
                arrow: {
                  sx: {
                    color: "#00305b",
                  },
                },
              }}
            >
              <Button
                className="promo-btn"
                variant="contained"
                onClick={() => setOpenPromoModal(true)}
                sx={{
                  width: "55px",
                  minWidth: "55px",
                  height: "55px",
                  borderRadius: "50%",
                  backgroundColor: "#00305b",
                  color: "white",

                  "&:hover": {
                    backgroundColor: "#00284a",
                  },
                }}
              >
                <ConfirmationNumberIcon />
              </Button>
            </Tooltip>
          </Box>
        </Grid>
      </Grid>

      {/* Modal ใส่ Promo Code */}
      <Modal open={openPromoModal} onClose={() => setOpenPromoModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",

            width: {
              xs: "90%",
              sm: "80%",
              md: 600,
            },

            maxWidth: "600px",

            bgcolor: "white",
            borderRadius: 2,
            boxShadow: 24,
            p: {
              xs: 2,
              sm: 3,
            },
          }}
        >
          {/* Title */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              {t("promo_code")}
            </Typography>
            <IconButton onClick={() => setOpenPromoModal(false)}>
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Radio Group */}

          {/* ---------------------- Dynamic Input Zone ---------------------- */}
          <Box sx={{ mt: 2 }}>
            {/* 1️⃣ Promo Code */}
            {promoType === "code" && (
              <Box>
                <TextField
                  fullWidth
                  label={t("promo_code")}
                  value={promoCodeInput}
                  onChange={handlePromoCodeChange}
                />

                {/* ถ้ามีผลลัพธ์ให้แสดงด้านล่าง */}
                {matchedPromo && (
                  <Box
                    sx={{
                      mt: 2,
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: "#f0f6ff",
                      border: "1px solid #b6d4fe",
                    }}
                  >
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                      {matchedPromo.name_promotion}
                    </Typography>

                    <Typography variant="body2" sx={{ mt: 1 }}>
                      {t("discount")}:{" "}
                      {matchedPromo.discount_promotion === "Percent"
                        ? `${matchedPromo.discount_value_promotion}%`
                        : `${matchedPromo.discount_value_promotion} ${t("currency_thb")}`}
                    </Typography>

                    <Typography variant="body2">
                      {t("valid_until")}: {getPromoValidText(matchedPromo)}
                    </Typography>
                  </Box>
                )}

                {/* ถ้าพิมพ์แล้วแต่ไม่ตรง */}
                {promoCodeInput && !matchedPromo && (
                  <Typography color="error" sx={{ mt: 1 }}>
                    ❌ {t("invalid_promo_code")}
                  </Typography>
                )}
              </Box>
            )}
          </Box>
          {/* ---------------------- End Dynamic Input Zone ---------------------- */}

          {/* Add Button */}
          <Box sx={{ mt: 3, textAlign: "center" }}>
            <Button
              variant="contained"
              onClick={() => {
                let promoData = null;

                if (promoType === "code" && matchedPromo) {
                  promoData = {
                    type: "code",
                    data: matchedPromo,
                  };
                }

                onApplyPromo?.(promoData); // 🔥 ส่งขึ้น HomePage
                setOpenPromoModal(false);
              }}
            >
              {t("apply")}
            </Button>
          </Box>
        </Box>
      </Modal>

      <Snackbar
        className="top--30"
        open={showAlert}
        autoHideDuration={3000}
        onClose={() => setShowAlert(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          sx={{
            borderRadius: 8,
            "@media (max-width:600px)": {
              height: "50%",
              width: "100%",
              fontSize: "0.6rem",
              "& .MuiOutlinedInput-root": {
                borderRadius: 8,
                height: "60%",
                width: "100%",
                fontSize: "0.6rem",
              },
            },
          }}
          elevation={6}
          variant="filled"
          severity="warning"
          onClose={() => setShowAlert(false)}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default SearchForm;
